import { render } from "./mercadopago-online.vue?vue&type=template&id=16aa39a9&scoped=true"
import script from "./mercadopago-online.vue?vue&type=script&lang=js"
export * from "./mercadopago-online.vue?vue&type=script&lang=js"

import "./mercadopago-online.vue?vue&type=style&index=0&id=16aa39a9&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16aa39a9"]])

export default __exports__